import {pxToRem} from '../../../utills/pxToRem'
import sizes from '../../foundations/sizes'

export const homeCategoryBannersPlaceholderStyle = {
    width: '100%',
    minHeight: pxToRem(396),
    '@media (max-width: 640px)': {
        minHeight: 0,
        aspectRatio: '486 / 515'
    }
}

export default {
    '.wds-demo-home-section': {
        margin: `${pxToRem(30)} 0`,

        [`@media (min-width: ${sizes.container.md})`]: {
            margin: `${pxToRem(40)} 0`
        },

        '.wdsh-mycavenders': {
            minHeight: pxToRem(250),
            overflow: 'hidden',
            position: 'relative',

            [`@media (min-width: ${sizes.container.md})`]: {
                display: 'flex',
                minHeight: pxToRem(396)
            },

            [`@media (min-width: ${sizes.container.xxxl})`]: {
                maxWidth: pxToRem(4096),
                width: `calc(100% - ${pxToRem(192)})`,
                margin: '0 auto'
            }
        },

        '.bg-image': {
            height: '100%',
            width: '100%',
            position: 'absolute',
            objectFit: 'cover',
            maxWidth: '100%'
        },

        '.custom-container': {
            position: 'relative',
            padding: `${pxToRem(82)} ${pxToRem(12)}`,
            textAlign: 'center',

            [`@media (min-width: ${sizes.container.md})`]: {
                padding: `${pxToRem(82)} ${pxToRem(16)}`,
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                maxWidth: pxToRem(1250),
                margin: 'auto'
            },

            '&.content-box': {
                maxWidth: pxToRem(360),
                boxSizing: 'content-box',

                [`@media (min-width: ${sizes.container.md})`]: {
                    display: 'block'
                }
            }
        },

        '.logo-container': {
            padding: `0 ${pxToRem(4)} ${pxToRem(30)}`,
            maxWidth: pxToRem(298),
            margin: '0 auto',
            width: '100%',
            img: {
                width: '100%',
                aspectRatio: 'auto 1616 / 1007'
            },

            [`@media (min-width: ${sizes.container.md})`]: {
                padding: '0',
                margin: 'auto 0'
            },

            [`@media (min-width: ${sizes.container.lg})`]: {
                maxWidth: pxToRem(400)
            }
        },

        '.content-container': {
            [`@media (min-width: ${sizes.container.md})`]: {
                maxWidth: pxToRem(362)
            }
        },

        '.content-heading': {
            fontWeight: 600,
            textTransform: 'uppercase',
            fontSize: pxToRem(18),
            marginBottom: pxToRem(20),
            letterSpacing: pxToRem(3),
            lineHeight: 'normal',

            [`@media (min-width: ${sizes.container.md})`]: {
                fontSize: pxToRem(22)
            }
        },

        '.content-paragraph': {
            marginBottom: pxToRem(20),
            fontSize: pxToRem(14),
            fontWeight: 400,
            letterSpacing: pxToRem(1.12),

            [`@media (min-width: ${sizes.container.md})`]: {
                marginBottom: pxToRem(26),
                fontSize: pxToRem(16),
                letterSpacing: pxToRem(1.28)
            }
        },

        '.clv-btn-secondary': {
            margin: 'auto',
            display: 'flex',
            width: pxToRem(260),
            height: pxToRem(35),
            justifyContent: 'center',
            alignItems: 'center',
            background: 'var(--chakra-colors-white)',
            color: 'var(--chakra-colors-cav_red)',
            fontSize: pxToRem(12),
            fontWeight: 700,
            lineHeight: pxToRem(13.5),
            letterSpacing: pxToRem(1.44),
            textTransform: 'uppercase',
            textDecoration: 'none',

            '&:hover': {
                background: 'var(--chakra-colors-cav_red)',
                color: 'var(--chakra-colors-white)',
                transform: 'scale(1.05)'
            },

            [`@media (min-width: ${sizes.container.md})`]: {
                width: pxToRem(295),
                height: pxToRem(40),
                padding: `${pxToRem(12)} ${pxToRem(20)}`,
                fontSize: pxToRem(14),
                letterSpacing: pxToRem(1.68)
            }
        }
    }
}
